import { InjectionToken } from '@angular/core';
import { EnvironmentConfig } from '../models/config.model';

export const ConfigService = new InjectionToken<EnvironmentConfig>('EnvironmentConfig');
